import { BillingInterval, BundleOption } from '../types';

export const BUNDLE_OPTIONS: BundleOption[] = [
  {
    years: 1,
    totalPrice: 10.0,
    pricePerYear: 10.0,
    discount: 0,
    savings: 0,
    label: '1 Year',
  },
  {
    years: 2,
    totalPrice: 18.0,
    pricePerYear: 9.0,
    discount: 10,
    savings: 2.0,
    label: '2 Years',
    badge: 'Save $2',
  },
  {
    years: 3,
    totalPrice: 25.0,
    pricePerYear: 8.33,
    discount: 17,
    savings: 5.0,
    label: '3 Years',
    badge: 'Save $5',
  },
  {
    years: 4,
    totalPrice: 32.0,
    pricePerYear: 8.0,
    discount: 20,
    savings: 8.0,
    label: '4 Years',
    badge: 'Best Value',
  },
  {
    years: 5,
    totalPrice: 40.0,
    pricePerYear: 8.0,
    discount: 20,
    savings: 10.0,
    label: '5 Years',
    badge: 'Max Savings',
  },
];

// Modern signup billing intervals; mirrors auth_server.BILLING_PLANS so the
// UI stays in sync with the backend price catalog. The actual displayed
// pricing is fetched from /api/subscription/plans, but these labels and
// orderings ensure a sensible default render before the network reply.
export interface BillingIntervalOption {
  id: BillingInterval;
  label: string;
  defaultPriceDisplay: string;
  defaultMonthlyEquivalent: string;
  badge?: string;
}

export const BILLING_INTERVAL_OPTIONS: BillingIntervalOption[] = [
  {
    id: 'month',
    label: 'Monthly',
    defaultPriceDisplay: '$1.50 / month',
    defaultMonthlyEquivalent: '$1.50/mo',
  },
  {
    id: 'quarter',
    label: 'Every 3 Months',
    defaultPriceDisplay: '$4.00 / 3 months',
    defaultMonthlyEquivalent: '$1.33/mo',
    badge: 'Save 11%',
  },
  {
    id: 'semiannual',
    label: 'Every 6 Months',
    defaultPriceDisplay: '$7.50 / 6 months',
    defaultMonthlyEquivalent: '$1.25/mo',
    badge: 'Save 17%',
  },
  {
    id: 'year',
    label: 'Yearly',
    defaultPriceDisplay: '$10.00 / year',
    defaultMonthlyEquivalent: '$0.83/mo',
    badge: 'Best Value',
  },
];

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const formatCents = (cents: number): string => formatCurrency(cents / 100);
